module.exports = __webpack_public_path__ + "static/media/slider-l5.980e5b89.webp";